export const name = "ST_ISRING";
export const summary = `Checks if a \`GEOGRAPHY\` value is a closed, simple linestring.`;
export const reference = `
## ST_ISRING

Checks if a \`GEOGRAPHY\` value is a closed, simple linestring.

\`\`\`
ST_ISRING(geography_expression)
\`\`\`

### Description

Returns \`TRUE\` if the input \`GEOGRAPHY\` is a linestring and if the linestring is both \`ST_ISCLOSED\` and simple. A linestring is considered simple if it doesn't pass through the same point twice (with the exception of the start and endpoint, which may overlap to form a ring).

An empty \`GEOGRAPHY\` isn't a ring.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
